<p *ngIf="tourItem?.tourRegistration">
  Toegevoegd aan toer door
  <span class="font-weight-bold">
    {{
      tourItem.tourRegistration?.by?.firstName
        | personName : tourItem.tourRegistration?.by?.lastName
    }}
  </span>
  op
  <span class="font-weight-bold">
    {{ tourItem.tourRegistration?.date | formatDate : '' : 'dd/MM/yyyy HH:mm' }}
  </span>
</p>
